import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getGuideDetailList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import {
	RESIDUE_GUIDE_EDIT_ENABLED,
	RESIDUE_WAREHOUSE_GUIDE_REGISTER_PATH,
} from '../legacy/constants';
import AddEditGuideDetailModal from './Add_Edit/AddEditGuideDetailModal';
import DeleteGuideDetail from './Delete/DeleteGuideDetail';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { Tooltip } from '@mantine/core';
import TraceabilityModal from '../Traceability/TraceabilityModal';

const GuideDetailsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorGuideDetails = createSelector(
		state => state.GuideDetails,
		guideDetail => ({
			guideDetailList: guideDetail.guideDetailList,
			isLoadingList: guideDetail.isLoadingList,
			isGuideDetailSuccess: guideDetail.isGuideDetailSuccess,
			error: guideDetail.error,
			isAdding: guideDetail.isAdding,
			isAdded: guideDetail.isAdded,
			isAddError: guideDetail.isAddError,
			isUpdating: guideDetail.isUpdating,
			isUpdated: guideDetail.isUpdated,
			isUpdateError: guideDetail.isUpdateError,
			isDeleting: guideDetail.isDeleting,
			isDeleted: guideDetail.isDeleted,
			isDeleteError: guideDetail.isDeleteError,
		})
	);

	const { guideDetailList, isLoadingList } = useSelector(selectorGuideDetails);

	useEffect(() => {
		dispatch(getGuideDetailList());
	}, []);

	const [dataGuideDetail, setDataGuideDetail] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete GuideDetail
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	const [traceOpen, setTraceOpen] = useState(false);
	const [traceGuideId, setTraceGuideId] = useState(null);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	const toggleTraceModal = useCallback(() => {
		setTraceOpen(prev => {
			if (prev) setTraceGuideId(null);
			return !prev;
		});
	}, []);

	const openTraceForGuide = useCallback(guideDetail => {
		const gid = guideDetail?.guide_id;
		if (!gid) return;
		setTraceGuideId(gid);
		setTraceOpen(true);
	}, []);

	// Delete Data
	const handleClickDelete = guideDetail => {
		setDataGuideDetail(guideDetail);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = guideDetail => {
		setDataGuideDetail(guideDetail);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'guideDetail',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										{RESIDUE_GUIDE_EDIT_ENABLED && (
											<li className='list-inline-item'>
												<Link
													to={`/residue/guides/${cellProps.row.original.guide_id}`}
													title='Editar guía'
												>
													<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
												</Link>
											</li>
										)}
										<li className='list-inline-item'>
											<Link
												to='#'
												title='Trazabilidad'
												onClick={e => {
													e.preventDefault();
													openTraceForGuide(cellProps.row.original);
												}}
											>
												<i className='ri-git-branch-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const guideDetailData =
														cellProps.row.original;
													handleClickDelete(guideDetailData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Residuo', accessorKey: 'residue.name', size: 'auto' },
			{ header: 'Cantidad', accessorKey: 'amount', size: 'auto' },
			{
				header: 'Estado',
				accessorKey: 'status_guide_detail',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.status_guide_detail
					let bgColor = status.bgcolor;
					let txColor = status.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{row.original.status_guide_detail?.name
									? row.original.status_guide_detail.name
									: ''}
							</span>
						</div>
					);
				},
			},
			{ 
			header: 'Guía', 
			accessorKey: 'guide.guide_number', 
			size: 'auto',
			Cell: ({ row }) => {
				const displayNumber = row.original.guide?.folio || row.original.guide?.guide_number || '-';
				return displayNumber;
			},
		},
			{
				header: 'Unidad de medida',
				accessorKey: 'unit_measurement.name',
				size: 'auto',
			},
			{
				header: 'Valor (CLP)',
				accessorKey: 'peso_value',
				size: 'auto',
			},
			{
				header: '¿Es orgánico?',
				accessorKey: 'organic',
				size: 'auto',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='disabled'
							name='disabled'
							disabled
							checked={row.original.organic}
						/>
					);
				},
			},
			{ header: 'Volumen', accessorKey: 'volumen', size: 'auto' },
		],
		[handleClickEdit, openTraceForGuide]
	);

	return (
		<React.Fragment>
			<div className='row'>
				<Col lg={12}>
					<div className='card'>
						<div className='card-header border-0'>
							<div className='d-flex align-items-center'>
								<h5 className='card-title mb-0 flex-grow-1 text-capitalize'>
									Lista de detalles de guías
								</h5>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<Link
											to={RESIDUE_WAREHOUSE_GUIDE_REGISTER_PATH}
											className='nav-link'
											data-key='t-basic-action'
										>
											<Tooltip label='Generar guía' position='top' withinPortal>
												<button type='button' className='btn d-flex align-items-center btn-tooltip-hover gap-1'>
													<i className='icon-plus icon-tooltop-size'></i>{' '}
													Generar guía
												</button>
											</Tooltip>
										</Link>
									</div>
								</div>
							</div>
						</div>
						<div className='card-body pt-3'>
							<ODataGrid
								columns={columns}
								data={guideDetailList || []}
								isLoadingData={isLoadingList}
								customToolbarActions={({ table }) => (
									<div className="d-flex justify-content-start gap-2">
										<Link
											to={RESIDUE_WAREHOUSE_GUIDE_REGISTER_PATH}
											className='nav-link'
											data-key='t-basic-action'
										>
											<Tooltip label='Generar guía' position='top' withinPortal>
												<button type='button' className='btn d-flex align-items-center btn-tooltip-hover gap-1'>
													<i className='icon-plus icon-tooltop-size'></i>{' '}
													Generar guía
												</button>
											</Tooltip>
										</Link>
									</div>
								)}
							/>
						</div>
					</div>
				</Col>
			</div>

			<AddEditGuideDetailModal
				dataGuideDetail={dataGuideDetail}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteGuideDetail
				dataGuideDetail={dataGuideDetail}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
			<TraceabilityModal
				isOpen={traceOpen}
				toggle={toggleTraceModal}
				entityId={traceGuideId}
			/>
		</React.Fragment>
	);
};

export default GuideDetailsList;
